'use strict';

module.exports = function (marty) {
  marty.when = require('./when');
  marty.fetch = require('./fetch');
  marty.Store = require('./store');
  marty.handles = require('./handles');
  marty.createStore = require('./createStoreClass');
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/marty-lib/modules/store/index.js
 ** module id = 586
 ** module chunks = 0
 **/